import React, { useState, useEffect } from 'react';
import fetchWithTimeout from '../../utils/fetchWithTimeout';
import env from '../../env';
import ImportantMessages from './ImportantMessages';

const url = env.EXTERNAL_VMA_API;

const ImportantMessageFallback = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        fetchWithTimeout(url, 3000)
            .then((response) => response.json())
            .then((fetchedData) => {
                if (fetchedData?.vma?.content?.length > 0) {
                    setData(fetchedData.vma.content);
                }
            })
            .catch(() => {});
    }, []);

    if (data?.length > 0) {
        return <ImportantMessages messages={data} />;
    }

    return null;
};

export default ImportantMessageFallback;
